import { render } from "./ProjectSectionCollections.vue?vue&type=template&id=0a1a02a1&scoped=true"
import script from "./ProjectSectionCollections.vue?vue&type=script&lang=js"
export * from "./ProjectSectionCollections.vue?vue&type=script&lang=js"

import "./ProjectSectionCollections.vue?vue&type=style&index=0&id=0a1a02a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1a02a1"]])

export default __exports__